import React from "react";
import Box from "@mui/material/Box";
import Modal from "@mui/material/Modal";
import DeleteCard from "src/components/atoms/DeleteCard";

function DeleteModal({ open, close, deleteMsg = () => {} }) {
  const style = {
    position: "absolute",
    top: "50%",
    left: "50%",
    width: { xs: "70%", sm: "70%", lg: "20%" },
    transform: "translate(-50%, -50%)",
    bgcolor: "background.paper",
    border: "1px solid #F0F0F0",
    borderRadius: "8px",
    outline: "none",
    overflowY: "visible",
    overflowX: "visible",
    scrollbarWidth: "none",
    maxHeight: 600,
  };
  return (
    <div>
      <Modal
        open={open}
        onClose={close}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
        BackdropProps={{
          style: {
            backgroundColor: "rgba(0, 0, 0, 0.2)",
          },
        }}
      >
        <Box sx={style}>
          <DeleteCard close={close} deleteMsg={deleteMsg}/>
        </Box>
      </Modal>
    </div>
  );
}

export default DeleteModal;
